import React from 'react'
import { FormControl, Typography, TextField } from '@mui/material';
import DatePicker from "react-datepicker";
import moment from 'moment';


export default function FilterSingleDate({ obj, i, handleDateFilter, reportIndex, showLabel = true }) {
    const isMaxDateRangeApplied = obj?.operator !== "beforeDate" || obj?.operator !== "afterDate";
    return (
        <FormControl className="" variant="outlined" sx={{ width: '100%' }} size="small">
            {showLabel ? <Typography className="report-form-label" variant="subtitle1" > {obj.displayName} </Typography> : null}
            <DatePicker dateFormat="dd/MM/yyyy"  
            autoComplete='off'
            maxDate={isMaxDateRangeApplied? new Date() : null} 
            className="report_form_ui_input_date" selected={obj?.values[0] ? new Date(obj?.values[0]): null} onChange={(e) => handleDateFilter(e, obj, i, 'singleDate', reportIndex)} isClearable  placeholderText='Select Date Range'/>
        </FormControl>
    )
}
